import { useEffect, useState } from "react";
import { api } from "../../api/client";
import { useToasts } from "../../state/toasts";
import { Empty } from "../../ui/components";

interface RolesResponse {
  permissions: string[];
  roles: { role: string; title: string; permissions: string[] }[];
}

/** Человеческие названия прав: в коде они машинные, в интерфейсе — нет. */
const PERMISSION_TITLES: Record<string, string> = {
  "orders.view": "Видеть заказы",
  "orders.status.kitchen": "Менять статусы на кухне",
  "orders.claim": "Забирать заказы в доставку",
  "orders.deliver": "Отмечать доставленным",
  "orders.note": "Оставлять внутренние заметки",
  "orders.cancel": "Отменять заказы",
  "orders.correct": "Менять состав оплаченного заказа",
  "orders.refund": "Оформлять возвраты",
  "orders.export": "Выгружать заказы",
  "customers.view": "Видеть телефоны клиентов",
  "menu.manage": "Редактировать меню и цены",
  "promotions.manage": "Управлять акциями и промокодами",
  "stoplist.manage": "Управлять стоп-листом",
  "benches.manage": "Управлять лавочками и QR",
  "devices.manage": "Устройства точки и долг по чекам",
  "settings.manage": "Настройки точки и график",
  "staff.manage": "Управлять сотрудниками",
  "audit.view": "Смотреть журнал действий",
  "analytics.view": "Смотреть аналитику"
};

export function RolesPage() {
  const { notify } = useToasts();
  const [data, setData] = useState<RolesResponse | null>(null);

  useEffect(() => {
    api
      .get<RolesResponse>("/api/admin/roles")
      .then(setData)
      .catch(error => notify(error instanceof Error ? error.message : "Не удалось загрузить права", "error"));
  }, [notify]);

  if (!data) return <Empty>Загружаем права…</Empty>;

  return (
    <>
      <div className="page-head">
        <div>
          <p className="eyebrow">Доступ</p>
          <h1>Роли и права</h1>
        </div>
      </div>

      <section className="panel">
        <header>
          <div>
            <h2>Что может каждая роль</h2>
            <p>Проверки в системе идут по правам, а не по названию роли — набор прав расширяется без переделки.</p>
          </div>
        </header>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Право</th>
                {data.roles.map(role => (
                  <th key={role.role} style={{ textAlign: "center" }}>
                    {role.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.permissions.map(permission => (
                <tr key={permission}>
                  <td>
                    {PERMISSION_TITLES[permission] ?? permission}
                    <br />
                    <small className="muted num">{permission}</small>
                  </td>
                  {data.roles.map(role => (
                    <td key={role.role} style={{ textAlign: "center" }}>
                      {role.permissions.includes(permission) ? (
                        <span className="chip chip-ready">да</span>
                      ) : (
                        <span className="muted">—</span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="tiny muted">
          Набор прав пока меняется в коде. Это сознательно: случайно снятая галочка оставила бы смену без доступа
          к возвратам в час пик, а заметили бы это не сразу.
        </p>
      </section>
    </>
  );
}
